import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="relative  bg-gray-800 text-white dark:border-t-4 border-black dark:bg-slate-800 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">

        <div id="footer-content" className="relative max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
            {/* Social Media Links */}
            <div className="flex-1">
              <h3 className="text-lg  font-semibold mb-4 sm:text-xl">Follow Us</h3>
              <div className="flex space-x-4 justify-center sm:justify-start flex-wrap">
                <a href="https://www.facebook.com/mina.isaac.505" target="blank" className="text-gray-400 hover:text-white">
                  <FiFacebook size={24} className="sm:size-26" />
                </a>
                <a href="https://x.com/minaIsaac481065" target="blank" className="text-gray-400 hover:text-white">
                  <FiTwitter size={24} className="sm:size-26" />
                </a>
                <a href="https://www.instagram.com/mina_isaac66/" target="blank" className="text-gray-400 hover:text-white">
                  <FiInstagram size={24} className="sm:size-26" />
                </a>
                <a href="https://www.linkedin.com/in/mina-isaac-6a98b427a/" target="blank" className="text-gray-400 hover:text-white">
                  <FiLinkedin size={24} className="sm:size-26" />
                </a>
              </div>
            </div>

            {/* Copyright */}
            <div className="flex-1 text-center sm:text-right text-sm sm:text-base">
              &copy; 2024 Mina Isaac. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
